import { Vector3 } from "three";
import { MidpointStakeLayout } from "@/data/content";

export const getCalculatedMidpointCoordinates = (
  midPointName,
  tcPosition,
  piPosition
) => {
  const distance = MidpointStakeLayout[midPointName].DISTANCE;
  const deflection = MidpointStakeLayout[midPointName].DEFLECTION;

  // Calculate the initial position along TC to PI line
  // This will be the correct distance from TC, but with a deflection angle of 0
  const distancePosition = new Vector3(tcPosition.x, 0, tcPosition.z);
  const direction = new Vector3()
    .subVectors(piPosition, tcPosition)
    .normalize();
  distancePosition.add(direction.multiplyScalar(distance));

  // Apply deflection rotation around TC point
  const rotationMatrix = new Vector3()
    .subVectors(distancePosition, tcPosition) // Get vector from TC to new position
    .applyAxisAngle(new Vector3(0, 1, 0), -deflection) // Rotate around Y-axis as though the vector is at the origin
    .add(tcPosition); // Translate back to TC-relative position;
  return rotationMatrix;
};
